// src\components\portal\portal_components\data_manager\data_table.js
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
  IconButton,
  Tooltip,
  Box,
  Button,
  CircularProgress, 
  Alert
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import DescriptionIcon from '@mui/icons-material/Description';
import WebIcon from '@mui/icons-material/Web';

const DataTable = ({ 
  filteredPages, 
  pendingOperations, 
  saving, 
  onRemovePage, 
  onSave, 
  onRemovePendingOperation,
  stats 
}) => {
  return (
    <>
      {/* Pages Table */}
      <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Page Name</TableCell>
              <TableCell>URL</TableCell>
              <TableCell align="center">Remove</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredPages.map((page, index) => (
              <TableRow 
                key={index}
                sx={{ 
                  backgroundColor: page.isRemoved ? '#ffebee' : 'inherit',
                  opacity: page.isRemoved ? 0.7 : 1
                }}
              >
                <TableCell>
                  <Chip
                    icon={page.type === 'doc' ? <DescriptionIcon /> : <WebIcon />}
                    label={page.type.toUpperCase()}
                    color={page.type === 'doc' ? 'success' : 'primary'}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                    {page.page_name || 'Untitled'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Tooltip title={page.page_link}>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        maxWidth: 300,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: '#1976d2',
                        cursor: 'pointer'
                      }}
                      onClick={() => window.open(page.page_link, '_blank')}
                    >
                      {page.page_link}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell align="center">
                  <IconButton
                    onClick={() => onRemovePage(index)}
                    color={page.isRemoved ? 'primary' : 'error'}
                    size="small"
                  >
                    {page.isRemoved ? <AddIcon /> : <DeleteIcon />}
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pending Operations */}
      {pendingOperations.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, color: '#ff9800' }}>
            Pending Operations ({pendingOperations.length})
          </Typography>
          <Box sx={{ maxHeight: 150, overflowY: 'auto' }}>
            {pendingOperations.map((op, index) => (
              <Chip
                key={index}
                label={`${op.operation.toUpperCase()}: ${op.url}`}
                color={op.operation === 'add' ? 'success' : 'error'}
                sx={{ m: 0.5 }}
                onDelete={() => onRemovePendingOperation(index)}
              />
            ))}
          </Box>
        </Box>
      )}



      {/* Save Button */}
      <Alert severity="info" sx={{ mt: 2, mb: 1 }}>
        Saved changes will be applied on the next scheduled update.
      </Alert>
      <Box display="flex" justifyContent="center" mt={3}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={onSave}
          disabled={saving || (pendingOperations.length === 0)}
          startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
          sx={{
            px: 4,
            py: 1.5,
            fontWeight: 'bold',
            backgroundColor: '#00796b',
            '&:hover': {
              backgroundColor: '#00796b',
            }
          }}
        >
          {saving ? 'Saving...' : `Save Changes`}
        </Button>
      </Box>
    </>
  );
};

export default DataTable;